import { render, staticRenderFns } from "./RestrictionsExtenDetail.vue?vue&type=template&id=31ffccab"
import script from "./RestrictionsExtenDetail.vue?vue&type=script&lang=ts"
export * from "./RestrictionsExtenDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports